import { useAuth0 } from "@auth0/auth0-react";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import useAPI from "../../api/hooks/useAPI";
import useColors from "../../api/hooks/useColors";
import { BootstrapContext } from "../../contexts/BootstrapContext";
import SvgToIcon from "../../icons/SvgToIcon";
import { getDisplayEmail } from "../../scenes/settings/account/utils";
import { icons } from "../../scenes/stack/environment/icons/iconExport";
import { UserPlatformAccessRole } from "../../utils/constants";

const UserMenu = ({ anchorElUser, handleCloseSettingsMenu }) => {
  const { logout } = useAuth0();
  const { trackEvent } = useAPI();
  const colors = useColors();
  const navigate = useNavigate();

  const { user: platformUser } = useContext(BootstrapContext);

  const handleSettingsClick = () => {
    navigate("settings");
    trackEvent(`User clicked on Settings in the user menu`);
    handleCloseSettingsMenu();
  };

  const handleManageTenantsClick = () => {
    navigate("tenants-management");
    trackEvent(`User clicked on Manage Tenants in the user menu`);
    handleCloseSettingsMenu();
  };

  return (
    platformUser && (
      <Menu
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseSettingsMenu}
        onBlur={handleCloseSettingsMenu}
        sx={{ zIndex: 2100 }}
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: "10px",
            padding: "8px 16px 8px 16px",
            minWidth: 200,
          },
        }}
      >
        <Box
          sx={{
            marginBottom: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
              {platformUser?.display_name}
            </Typography>
            <Box
              sx={{
                backgroundColor: colors.Secondary_soft_darker,
                color: colors.secondary_darker,
                ml: "48px",
                borderRadius: "8px",
                p: "6px",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="caption"
                sx={{ mx: "8px", alignItems: "center" }}
              >
                {platformUser?.role}
              </Typography>
            </Box>
          </Box>
          <Typography sx={{ color: colors.text_primary }} variant="caption">
            {getDisplayEmail(platformUser)}
          </Typography>
        </Box>
        <Divider />
        <MenuItem
          onClick={handleSettingsClick}
          sx={{ padding: 0, height: "36px" }}
        >
          <SettingsRoundedIcon
            sx={{
              mr: 1,
              fontSize: "20px",
            }}
          />
          <Typography
            variant="caption"
            sx={{
              alignItems: "center",
            }}
          >
            Settings
          </Typography>
        </MenuItem>
        {platformUser?.access_role === UserPlatformAccessRole.MSSP && (
          <MenuItem
            onClick={handleManageTenantsClick}
            sx={{ padding: 0, height: "36px" }}
          >
            <SvgToIcon
              IconLogo={icons.MultiTenantIcon}
              style={{ mr: 1, width: "20px" }}
            />
            <Typography
              variant="caption"
              sx={{
                alignItems: "center",
              }}
            >
              Manage tenants
            </Typography>
          </MenuItem>
        )}
        <Divider sx={{ my: "0 !important" }} />
        <MenuItem
          onClick={() => {
            logout({
              logoutParams: { returnTo: window.location.origin },
            });
          }}
          sx={{ padding: 0, marginRight: 0, height: "36px" }}
        >
          <LogoutRoundedIcon sx={{ mr: 1, fontSize: "20px" }} />
          <Typography variant="caption">Log Out</Typography>
        </MenuItem>
      </Menu>
    )
  );
};

export default UserMenu;
